import { connect } from "react-redux";
import PropTypes from "prop-types";
import TaxesFeesInfo from "./TaxesFeesInfo";
import { getTotalExcludedTaxes } from "app/pages/Booking/bookingSelectors";

const TaxesFeesInfoContainer = ({ totalExcludedTaxes }) => {
	return <TaxesFeesInfo amount={totalExcludedTaxes} />;
};

TaxesFeesInfoContainer.propTypes = {
	totalExcludedTaxes: PropTypes.number,
};

const mapStateToProps = state => ({
	totalExcludedTaxes: getTotalExcludedTaxes(state),
});

export default connect(mapStateToProps)(TaxesFeesInfoContainer);
